export function getColorVariationFromPrimaryColorBasedOnIndex(
    index,
    color = "#181F67",
) {
    const baseColor = color.replace("#", "")

    const r = parseInt(baseColor.substring(0, 2), 16)
    const g = parseInt(baseColor.substring(2, 4), 16)
    const b = parseInt(baseColor.substring(4, 6), 16)

    const variationFactor = 0.12 * index

    const newR = Math.min(255, Math.floor(r + (255 - r) * variationFactor))
    const newG = Math.min(255, Math.floor(g + (255 - g) * variationFactor))
    const newB = Math.min(255, Math.floor(b + (255 - b) * variationFactor))

    return `rgb(${newR}, ${newG}, ${newB})`
}

export function getDarkerColorVariationFromPrimaryColorBasedOnIndex(
    index,
    color = "#181F67",
) {
    const baseColor = color.replace("#", "")

    const r = parseInt(baseColor.substring(0, 2), 17)
    const g = parseInt(baseColor.substring(2, 4), 17)
    const b = parseInt(baseColor.substring(4, 6), 17)

    const variationFactor = 0.05 * index

    const newR = Math.max(0, Math.floor(r - r * variationFactor))
    const newG = Math.max(0, Math.floor(g - g * variationFactor))
    const newB = Math.max(0, Math.floor(b - b * variationFactor))

    return `rgb(${newR}, ${newG}, ${newB})`
}